import { Card, CardContent } from "../ui/Card";
import { AlertCircle } from "lucide-react";
import { useUser } from "../Use-auth";
import { Redirect } from "wouter";

export default function NotFound() {
    const { data: user, isLoading } = useUser();

    if (isLoading) return null;

    if (!user) {
        return <Redirect to="/login" />;
    }

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-gray-50">
            <Card className="w-full max-w-md mx-4">
                <CardContent className="pt-3 sm:pt-6">
                    <div className="flex mb-4 gap-2">
                        <AlertCircle className="h-4 w-4 sm:h-8 sm:w-8 text-red-500" />
                        <h1 className="text-sm sm:text-2xl font-bold text-gray-900">404 Page Not Found</h1>
                    </div>

                    <p className="mt-4 text-xs sm:text-sm text-gray-600">
                        Did you forget to add the page to the router?
                    </p>
                </CardContent>
            </Card>
        </div>
    );
}
